import {container, size} from '../theme/variables'
import {pxValue} from '../units'
import type {Theme} from './types'

import gridCss from './grid.css'

const grid: {
  // -- Classnames
  container: string
  shrinkableContainer: string
  growableContainer: string
  rowContainer: string
  row: string
  rows: string
  reverse: string
  width_grow: string
  width_fill: string
  width_max: string
  width_1: string
  width_1root: string
  width_2: string
  width_2root: string
  width_3: string
  width_3root: string
  width_4: string
  width_4root: string
  width_5: string
  width_5root: string
  width_6: string
  width_6root: string
  width_7: string
  width_7root: string
  width_8: string
  width_8root: string
  width_9: string
  width_9root: string
  width_10: string
  width_10root: string
  width_11: string
  width_11root: string
  width_12: string
  width_12root: string
  width_1of2: string
  width_1of2root: string
  width_1of3: string
  width_1of3root: string
  width_1of4: string
  width_1of4root: string
  width_1of5: string
  width_1of5root: string
  width_2of3: string
  width_2of3root: string
  width_3of4: string
  width_3of4root: string
  width_xs: string
  width_s: string
  width_m: string
  width_l: string
  width_xl: string
  width_xxl: string
  height_max: string
  height_xs: string
  height_s: string
  height_m: string
  height_l: string
  height_xl: string
  height_xxl: string
  height_xxxl: string
} = gridCss as any

export {grid}

export function getGutterSize(): number {
  return pxValue(size.s)
}

export function getContainerMinWidth(): number {
  return pxValue(container.minWidth)
}

export function getContainerMaxWidth(): number {
  return pxValue(container.maxWidth)
}

export function getContainerPadding(): number {
  return pxValue(container.padding)
}

// Returns proper className for specified width
function getGridClassName(key, theme) {
  let result = ''
  if (grid[key]) {
    result += grid[key]
  }
  if (theme && theme[key]) {
    result += ' ' + theme[key]
  }
  return result
}

// Returns proper className for specified width
export function getWidthClassName(
  width?: string | null,
  theme?: Theme | null
): string {
  return width ? getGridClassName(`width_${width}`, theme) : ''
}

// Returns proper className for specified height
export function getHeightClassName(
  height?: string | null,
  theme?: Theme | null
): string {
  return height ? getGridClassName(`height_${height}`, theme) : ''
}

export function getSizeClassName(
  {width, height}: {width?: string | null; height?: string | null},
  theme?: Theme | null
): string {
  const widthClassname = width && getWidthClassName(width, theme)
  const heightClassname = height && getHeightClassName(height, theme)

  return `${widthClassname || ''} ${heightClassname || ''}`
}
